import { createFileRoute } from "@tanstack/react-router"
import { Container, Title, Text, Paper, Stack, List } from "@mantine/core"

export const Route = createFileRoute("/privacy")({
  component: PrivacyPolicyComponent,
})

function PrivacyPolicyComponent() {
  return (
    <Container size="md" py="xl">
      <Paper shadow="sm" radius="md" p="xl">
        <Stack gap="xl">
          <div>
            <Title order={1} mb="md">
              Privacy Policy
            </Title>
            <Text c="dimmed">
              Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
            </Text>
          </div>

          <Stack gap="lg">
            <div>
              <Title order={2} size="h3" mb="sm">
                Information We Collect
              </Title>
              <Text>
                RTEFN is committed to protecting your privacy. We collect minimal information necessary to provide our
                services:
              </Text>
              <List mt="sm">
                <List.Item>Basic analytics data to improve site performance</List.Item>
                <List.Item>Information you voluntarily provide when contacting us</List.Item>
                <List.Item>Technical information like IP addresses and browser types for security purposes</List.Item>
              </List>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                How We Use Information
              </Title>
              <Text>Any information we collect is used solely to:</Text>
              <List mt="sm">
                <List.Item>Provide and improve our transparency advocacy services</List.Item>
                <List.Item>Respond to your inquiries and communications</List.Item>
                <List.Item>Maintain site security and prevent abuse</List.Item>
                <List.Item>Analyze site usage to enhance user experience</List.Item>
              </List>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                Information Sharing
              </Title>
              <Text>
                We do not sell, trade, or otherwise transfer your personal information to third parties. We may share
                information only when:
              </Text>
              <List mt="sm">
                <List.Item>Required by law or legal process</List.Item>
                <List.Item>Necessary to protect our rights or the safety of others</List.Item>
                <List.Item>You have given explicit consent</List.Item>
              </List>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                Data Security
              </Title>
              <Text>
                We implement appropriate security measures to protect your information against unauthorized access,
                alteration, disclosure, or destruction. However, no method of transmission over the internet is 100%
                secure.
              </Text>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                Third-Party Services
              </Title>
              <Text>
                Our website may use third-party services for analytics and functionality. These services have their own
                privacy policies and terms of service. We encourage you to review their policies.
              </Text>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                Your Rights
              </Title>
              <Text>You have the right to:</Text>
              <List mt="sm">
                <List.Item>Request information about what data we collect</List.Item>
                <List.Item>Request correction or deletion of your personal information</List.Item>
                <List.Item>Opt out of non-essential data collection</List.Item>
                <List.Item>Contact us with privacy-related concerns</List.Item>
              </List>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                Changes to This Policy
              </Title>
              <Text>
                We may update this privacy policy from time to time. Any changes will be posted on this page with an
                updated revision date. Continued use of our site after changes constitutes acceptance of the updated
                policy.
              </Text>
            </div>

            <div>
              <Title order={2} size="h3" mb="sm">
                Contact Us
              </Title>
              <Text>
                If you have questions about this privacy policy or our data practices, please contact us at:{" "}
                <Text component="a" href="mailto:privacy@rtefn.com" c="blue">
                  privacy@rtefn.com
                </Text>
              </Text>
            </div>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  )
}
